export const FUTURE_YEARS: number = 11;
export const PAST_YEARS: number = 100;
export const MONTH: number = 12;

export const DATE_LABEL = 'DD';
export const MONTH_LABEL = 'MMM';
export const YEAR_LABEL = 'YYYY';
